import React, { Component, Fragment } from 'react';
import { SURVEYS_BY_LOC, SURVEYS_BY_MAP, SURVEYS_NO_LOC, WITHIN_RAD } from '../App';
import LoadingSpinner from './LoadingSpinner';
import EmptyState from './EmptyState';

const haversine = require('haversine')




class Tasks extends Component {

    componentDidMount() {
        const { getTasks, getLocation, myLoc, GetHeadingpoint, isLoaded, tasks_by_loc } = this.props;

        getLocation();
        GetHeadingpoint();

        // Don't re-fetch if tasks are already in state
        if (isLoaded && tasks_by_loc?.length > 0) return;

        if (myLoc?.lat) {
            getTasks(SURVEYS_BY_LOC, myLoc.lat, myLoc.lon);
        }
    }

    componentDidUpdate(prevProps) {
        const { getTasks, myLoc, isLoaded } = this.props;
        if (!prevProps.myLoc?.lat && myLoc?.lat && !isLoaded) {
            getTasks(SURVEYS_BY_LOC, myLoc.lat, myLoc.lon);
        }
    }

    componentWillUnmount() {}


    render_surveys_by_loc = (loc, index) => {
        const { onActivateLoc, getArrowPointingtoLoc } = this.props;
        
   
        if (loc.loc_scope) 
            return (
                <li className="list-group-item border-0 px-0" key={loc.loc_scope}>
                    <div className="card shadow-sm border-0 mb-2">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <h6 className="mb-0 fw-semibold">{loc.loc_name}</h6>
                                <button
                                    onClick={() => onActivateLoc(index)}
                                    className="btn btn-primary btn-sm"
                                >
                                    Entrar
                                </button>
                            </div>
                            <div className="text-muted small mb-2">
                                {loc.loc_address} · {loc.loc_distance} mts
                                <img
                                    className="image-option-gallery ms-2"
                                    width={20}
                                    height={20}
                                    src={getArrowPointingtoLoc(loc.loc_lat, loc.loc_lon)}
                                    alt="Dirección"
                                />
                            </div>
                            {loc.loc_surveys.map((svy) => (
                                <div className="mb-1" key={svy.survey}>
                                    <div className="small fw-semibold">{svy.survey_title}</div>
                                    <div className="small text-muted">
                                        {svy.questions_per_survey} pregunta
                                        {svy.questions_per_survey > 1 ? 's ' : ' '} por encuesta<br />
                                        {svy.surveys_to_complete - svy.surveys_completed} encuesta
                                        {(svy.surveys_to_complete - svy.surveys_completed) > 1 ? 's' : ''} por completar
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </li>
            )
        else return null


    }

    render() {
    
        const { tasks_by_loc, isLoaded, toogleClick, update_distance } = this.props;
  

        let sorted_tbl = []
        

        if (isLoaded === false) {
            return <LoadingSpinner message="Cargando tareas…" />
        }
        if (tasks_by_loc.length === 0) {
            return <EmptyState message="No hay encuestas cerca de ti." />
        }

        sorted_tbl = update_distance(tasks_by_loc)
            .map((loc, origIdx) => ({ ...loc, _origIdx: origIdx }))
            .sort((a, b) => a.loc_distance - b.loc_distance);
        return (
                <Fragment>
                    <nav className="navbar-light bg-light py-2 border-bottom d-flex justify-content-between align-items-center px-2" >
                    <span className="navbar-brand mb-0 h6">Tareas</span>
                        <div className="btn-group" role="group" data-toggle="buttons">
                            <button type="button" className="btn btn-sm btn-outline-secondary active"
                                onClick={() => toogleClick(SURVEYS_BY_LOC)}>List</button>
                            <button type="button" className="btn btn-sm btn-outline-secondary"
                                onClick={() => toogleClick(SURVEYS_BY_MAP)}>Map</button>
                        </div>
                    </nav>
                    <ul className="list-group list-group-flush mt-2">
                        {sorted_tbl.map((loc) => (
                            this.render_surveys_by_loc(loc, loc._origIdx)
                        ))}
                    </ul>
                </Fragment>
            )
    }



}


export default Tasks;